import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const br: SugarElementInfo = { name: "br", availableChildren: { type: AvailableChildrenType.NoChildren } };
